$(document).ready(function($) {
    /* Do not trigger keyboard popup on iOS*/
    $(document).on('mousedown', 'input[readonly]', function(e) {
        e.preventDefault();
    });
});